import React, { useMemo } from 'react';
import { ListColumnType } from 'types/ListTypes';
import AbstractList from 'components/lists/AbstractList';

const TimeRowList: React.FC = () => {
    // Specify the columns of this list
    const columns: ListColumnType[] = useMemo(() => [
        { 
            width: '2fr', 
            field: 'assignee',
            label: 'assignee' 
        },
        { 
            width: '1fr', 
            field: 'start_datetime', 
            label: 'Start' 
        },
        { 
            width: '1fr', 
            field: 'end_datetime', 
            label: 'End' 
        },
    ], []);

    return (
        <AbstractList
            query={{
                endpoint: 'get_timerow_list',
                defaultParams: { 'deleted': false },
                object: 'timerow'
            }}
            objectName='timerow.general.object_name'
            columns={columns}
            showAddButton={false}
            isPaginated={true}
        />
    );
};

export default TimeRowList;